(function (angular) {
	angular.module('bizPartEngage').service('modules.event.service', eventService);

	eventService.$inject = ["$http"];

	function eventService($http) {
		this.GetOneEvent = function (id) {
			return $http.get(siteRootPath + 'api/event/GetOneEventForUser?' + $.param({ eventId: id }));
		};

		this.UpdateParticipationStatus = function (eventId, newStatus, email, comment) {
			return $http.post(getServicePath() + 'UpdateParticipationStatus', {
				EventId: eventId,
				Status: newStatus,
				Email: email,
				Comment: comment
			}, {
				headers: {
					IgnoreLoader: true
				}
			});
		}
	}

})(window.angular);
